import { render, staticRenderFns } from "./followCount.vue?vue&type=template&id=05fc0332&"
import script from "./followCount.vue?vue&type=script&lang=js&"
export * from "./followCount.vue?vue&type=script&lang=js&"
import style0 from "./followCount.vue?vue&type=style&index=0&id=05fc0332&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports